import { type ReactNode, useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet-async'

import type { LandingLocale } from '@/navigation/locale'
import { clearShellSeoFallbacksOnce } from '@/shared/lib/clearShellSeoFallbacksOnce'

type PageHelmetProps = {
    children: ReactNode
    locale?: LandingLocale
}

/** Helmet wrapper that removes static shell SEO fallbacks to avoid duplicates on React 19. */
export function PageHelmet({ children, locale }: PageHelmetProps) {
    useLayoutEffect(() => {
        clearShellSeoFallbacksOnce()
    }, [])

    return <Helmet htmlAttributes={locale ? { lang: locale } : undefined}>{children}</Helmet>
}
